import { DownloadDialog } from '~/components/Global/Dialog/DownloadDialog';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ListCard } from '~/components/Global/Card';
import { TDownloadableResource } from '~/types/common.type';
import { RootState, useAppDispatch } from '~/store';
import { setShowLoginDialog } from '~/store/user';
import { getterIsValidLogin } from '~/store/user/userGetter';

const EMPTY_LIST: TDownloadableResource[] = [];

type TProps = {
  lists: {
    [resource2: string]: {
      [resource3: string]: TDownloadableResource[];
    };
  };
  resource1: string;
};

export const ListDownloadGroup = ({ lists, resource1 }: TProps) => {
  const dispatch = useAppDispatch();
  const [labels, setLabels] = useState<string[]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const ownInfo = useSelector((state: RootState) => state.user.ownInfo);
  const isValidLogin = useSelector(getterIsValidLogin);
  // 列表開著時下載狀態會一直變，每次都從最新的 lists 取，不能在打開時存成快照（NBX3-1117）
  const [, dialogLabel, dialogSubLabel] = labels;
  const list = lists[dialogLabel]?.[dialogSubLabel] ?? EMPTY_LIST;

  return (
    <>
      {Object.entries(lists).map(([label, content]) => (
        <ListCard
          key={label}
          label={label}
          list={content}
          handleSingleDownload={(subLabel: string) => {
            if (!ownInfo || !isValidLogin) {
              dispatch(setShowLoginDialog(true));
              return;
            }
            setIsDialogOpen(true);
            setLabels([resource1, label, subLabel]);
          }}
        />
      ))}
      <DownloadDialog
        currentList={list}
        labels={labels}
        open={isDialogOpen}
        handleClose={() => {
          setIsDialogOpen(false);
        }}
      />
    </>
  );
};
